export default __webpack_public_path__ + "static/monica-reactconf2-30c9754a388d9b0f5dcb051b0c573bdd.jpeg";